import { BlockchainID, IApiUserGroupParams } from 'multirpc-sdk';

import { ALL_WHITELIST_BLOCKCHAINS_VALUE } from 'modules/projects/const';
import { MultiService } from 'modules/api/MultiService';
import { TFAQueryFnParams } from 'modules/tfa/types';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { web3Api } from 'store/queries';

import { updateProjectWhitelistBlockchains } from './utils/updateProjectWhitelistBlockchains';
import { updateProjectsWhitelistsBlockchains } from './utils/updateProjectsWhitelistsBlockchains';

function prepareChains(chain: string) {
  if (chain === 'btc_mainnet') return 'btc';

  return chain;
}

export interface AddBlockchainsToWhitelistParams extends IApiUserGroupParams {
  userEndpointToken: string;
  blockchains: BlockchainID[];
}

export const {
  endpoints: { addBlockchainsToWhitelist },
  useAddBlockchainsToWhitelistMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    addBlockchainsToWhitelist: build.mutation<
      BlockchainID[],
      TFAQueryFnParams<AddBlockchainsToWhitelistParams>
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async ({
          params: { blockchains, group, userEndpointToken },
          totp,
        }) => {
          const service = MultiService.getService().getAccountingGateway();

          const preparedChains =
            blockchains.length === 0
              ? [ALL_WHITELIST_BLOCKCHAINS_VALUE]
              : blockchains.map(prepareChains);

          const data = await service.addBlockchainsToWhitelist(
            preparedChains,
            {
              token: userEndpointToken,
              group,
            },
            totp,
          );

          return { data };
        },
      }),
      onQueryStarted: async (
        { params: { group: teamAddress, userEndpointToken } },
        { dispatch, getState, queryFulfilled },
      ) => {
        const { data: blockchains } = await queryFulfilled;

        updateProjectWhitelistBlockchains({
          blockchains,
          dispatch,
          teamAddress,
          userEndpointToken,
        });

        updateProjectsWhitelistsBlockchains({
          blockchains,
          dispatch,
          getState,
          teamAddress,
          userEndpointToken,
        });
      },
    }),
  }),
  overrideExisting: true,
});
